export function ServerAPI(API, Method, Data = {}){

  // Endpoints that do not require an auth token.
  // `get_dashboard_snapshot_by_token` is public per spec — recipients of a
  // shared dashboard link do not need a Visiopt login.
  const noTokenAPIs = ['login','get_member_list','forgot_password','reset_password','get_dashboard_snapshot_by_token','support_login'];

  var APIHeaders = new Headers();
  APIHeaders.append("Content-Type", "application/json");
  if(!noTokenAPIs.includes(API)){
    APIHeaders.append("Authorization", "Bearer " + visiUserToken());
  }

  var raw = JSON.stringify(Data);

  var requestOptions = {
    method: Method,
    headers: APIHeaders,
    body: raw,
    redirect: 'follow'
  };

  if(Method === 'GET'){
    delete requestOptions.body
  }

  return requestOptions;
  
}

export function visiMemberData(){
  if(localStorage.getItem('visiMemberData') !== null){
    let visiMemberData = atob(localStorage.getItem('visiMemberData'));
    if(visiMemberData && visiMemberData !== ''){
      return JSON.parse(visiMemberData);
    }else{
      return false;
    }
  }else{
    return false;
  }
}

export function visiUserData(){
  if(localStorage.getItem('visiUserData') !== null){
    let visiUserData = atob(localStorage.getItem('visiUserData'));
    if(visiUserData && visiUserData !== ''){
      return JSON.parse(visiUserData);
    }else{
      return false;
    }
  }else{
    return false;
  }
  
}

// Returns true only for the Ad Lookup role (role=5). Uses a strict role-name check
// against the outer key of access_permission so it cannot accidentally match other roles.
export function isAdLookupRole(){
  const data = visiUserData();
  if(!data || !data.access_permission){
    return false;
  }
  const ap = data.access_permission;
  if(Array.isArray(ap)){
    return false;
  }
  return Object.prototype.hasOwnProperty.call(ap, 'adlookup');
}

export function visiUserToken(){

  if(localStorage.getItem('visiUserData') !== null){
    let visiUserData = atob(localStorage.getItem('visiUserData'));
    if(visiUserData && visiUserData !== ''){
      return JSON.parse(visiUserData).visi_login_token;
    }else{
      return false;
    }
  }else{
    return false;
  }
}

export function visiUserId(){
  if(localStorage.getItem('visiUserData') !== null){
    let visiUserData = atob(localStorage.getItem('visiUserData'));
    if(visiUserData && visiUserData !== ''){
      return JSON.parse(visiUserData).member_id;
    }else{
      return false;
    }
  }else{
    return false;
  }
  
}

export function visiUserSession(){

  if(visiUserId()){
    let visiUserSession = localStorage.getItem('visiUser_'+visiUserId());
    if(visiUserSession && visiUserSession !== ''){
      return JSON.parse(visiUserSession);
    }else{
      return false;
    }
  }else{
    return false;
  }
  
}

export function setVisiUserSession(key, value){
  if(visiUserId()){
    let visiUserSession = localStorage.getItem('visiUser_'+visiUserId());
    const existingData = JSON.parse(visiUserSession) || {};
    if(key === 'page'){
      existingData.page = value;
    }
    if(key === 'website'){
      existingData.website = value;
    }
    if(key === 'funnel'){
      existingData.funnel = value;
    }
    if(key === 'time'){
      existingData.time = value;
    }
    if(key === 'start_date'){
      existingData.start_date = value;
    }
    if(key === 'end_date'){
      existingData.end_date = value;
    }
    if(key === 'reviewing_test_start_date'){
      existingData.reviewing_test_start_date = value;
    }
    if(key === 'reviewing_test_end_date'){
      existingData.reviewing_test_end_date = value;
    }
    if(key === 'expanded_report_view'){
      existingData.expanded_report_view = value;
    }
    if(key === 'expanded_test_view'){
      existingData.expanded_test_view = value;
    }
    if(key === 'impact_summary_collapsed'){
      existingData.impact_summary_collapsed = value;
    }
    localStorage.setItem("visiUser_"+visiUserId(), JSON.stringify(existingData));
  }else{
    return false;
  }
  
}